import { langSelector } from '../App/selectors';
import { arrayToObject, prop } from '../../utilities';
import { getArticleTeasers } from '../../utilities/article';
import API from '../../services/API';

export const namespace = 'CMS';

const requestCMSCategoriesTree = (sectionId: string) => ({
  type: 'CMS/REQUEST_CATEGORIES',
  payload: { sectionId },
});

const receiveCMSCategoriesTreeSuccess = (
  sectionId: string,
  sitemap,
  sitemapObj,
) => ({
  type: 'CMS/RECEIVE_CATEGORIES_SUCCESS',
  payload: { sectionId, sitemap, sitemapObj },
});

const receiveCMSCategoriesTreeError = (sectionId: string, error) => ({
  type: 'CMS/RECEIVE_CATEGORIES_ERROR',
  payload: { sectionId, error },
});

export const loadCMSCategoriesTree = (sectionId: string) => {
  return async (dispatch, getState, API) => {
    try {
      if (!getState().cms.sections?.[sectionId]?.sitemap) {
        dispatch(requestCMSCategoriesTree(sectionId));
        const { sitemap_tree } = await API.loadSitemapSubtree(
          sectionId,
          {},
          { xAcceptLanguage: getState().general.lang },
        );
        const sitemapObj = arrayToObject(sitemap_tree, 'id');
        dispatch(
          receiveCMSCategoriesTreeSuccess(sectionId, sitemap_tree, sitemapObj),
        );
      }
    } catch (e) {
      dispatch(receiveCMSCategoriesTreeError(sectionId, e));
    }
  };
};

const receiveCMSSectionMeta = (sectionId: string, meta: any) => ({
  type: 'CMS/RECEIVE_SECTION_META',
  payload: { sectionId, meta },
});

export const loadCMSSectionMeta = (sectionId: string) => {
  return async (dispatch, getState, API) => {
    try {
      const lang = langSelector(getState());
      const section = await API.loadSitemap(
        sectionId.toString(),
        {},
        { xAcceptLanguage: lang },
      );
      const meta = {
        name: prop(section, 'name', ''),
        meta: prop(section, 'content.json_content.meta', {}),
      };
      dispatch(receiveCMSSectionMeta(sectionId, meta));
      return meta;
    } catch (e) {
      return null;
    }
  };
};

const requestCMSArticles = (sectionId: string) => ({
  type: 'CMS/REQUEST_ARTICLES',
  payload: { sectionId },
});

const receiveCMSArticlesSuccess = (sectionId: string, articles) => ({
  type: 'CMS/RECEIVE_ARTICLES_SUCCESS',
  payload: { sectionId, articles },
});

const receiveCMSArticlesError = (sectionId: string, error: any) => ({
  type: 'CMS/RECEIVE_ARTICLES_ERROR',
  payload: { sectionId, error },
});

export const loadCMSArticles = (
  sectionId: string,
  sitemapId: number | null = null,
  limit: number = 6,
  offset: number = 0,
) => {
  return async (dispatch, getState, API) => {
    try {
      const lang = langSelector(getState());
      dispatch(requestCMSArticles(sectionId));
      const paramsObject: any = { limit, offset };
      if (!sitemapId) {
        paramsObject.sitemapUniqueId = sectionId;
      } else {
        paramsObject.sitemapId = sitemapId;
      }

      const articles = await API.loadArticles(
        {
          ...paramsObject,
          sfForm: 'Article',
          isPublished: 1,
          sort: 'created_date',
          sortDir: 'desc',
        },
        { xAcceptLanguage: lang },
      );

      dispatch(
        receiveCMSArticlesSuccess(sectionId, getArticleTeasers(articles)),
      );
    } catch (e) {
      dispatch(receiveCMSArticlesError(sectionId, e));
    }
  };
};

export const submitContactForm = async (
  email,
  message,
  name,
  lang,
): Promise<boolean> => {
  try {
    return new Promise(resolve => {
      (window as any).grecaptcha.enterprise.ready(async () => {
        try {
          const token = await (window as any).grecaptcha.enterprise.execute(
            `${process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY}`,
            { action: 'submit' },
          );

          if (email && message && name && token) {
            await API.contactForm(
              {},
              {
                email: email,
                message: message,
                name: name,
                token: token,
              },
              {
                xAcceptLanguage: lang,
              },
            );
            resolve(true);
          } else {
            resolve(false);
          }
        } catch (e) {
          console.log('e: ', e);
          resolve(false);
        }
      });
    });
  } catch (e) {
    console.log(e);
    return false;
  }
};
